import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { useNavigate } from 'react-router';
import { useGetConnectionDetails } from '../../../hooks/useGetConnectionDetails';
import useTracking from '../../../hooks/useTracking';
import {
  EventCategories,
  EventLabels,
  EventNames,
} from '../../../utils/trackingEvents';
import { AlertBanner } from '../AlertBanner';

export const SetupConnectionsBanner: React.FC = () => {
  const { track } = useTracking();
  const navigate = useNavigate();

  const {
    hasAllRequiredProfiles,
    missingCronofyTimezone,
    loading: connectionDetailsLoading,
  } = useGetConnectionDetails();

  const shouldShowSetupConnectionsBanner =
    !connectionDetailsLoading && !hasAllRequiredProfiles;

  if (shouldShowSetupConnectionsBanner) {
    return (
      <AlertBanner
        icon={faExclamationCircle}
        primaryText="Complete your Coach Hub profile."
        secondaryText="You must set up your connections before members can book sessions with you."
        ctaText="Set Up Connections"
        ctaOnClick={() => {
          track(EventNames.ButtonClick, {
            event_category: EventCategories.Settings,
            event_label: EventLabels.SetUpConnections,
          });
          navigate('/app/settings/connections/');
        }}
      />
    );
  }

  const shouldShowMissingCronofyDefaultCalendar =
    !connectionDetailsLoading && missingCronofyTimezone;

  if (shouldShowMissingCronofyDefaultCalendar) {
    return (
      <AlertBanner
        icon={faExclamationCircle}
        primaryText="We're missing some calendar details."
        secondaryText='Please click "Save Changes" on the availability calendar to update your profile.'
        ctaText="Update Availability"
        ctaOnClick={() => {
          track(EventNames.ButtonClick, {
            event_category: EventCategories.Settings,
            event_label: EventLabels.UpdateAvailability,
          });
          navigate('/app/settings/availability/');
        }}
      />
    );
  }

  return null;
};
